import _ from "lodash";
import React from "react";
import {
  AssessmentOutlined,
  DashboardOutlined,
  HomeOutlined,
  SettingsOutlined,
  ManageMembersOutlined,
  // DeleteOutlined,
  TableOutlined,
  AssessmentApplicableOutlined,
  GoalsOutlined,
  AttendanceOutlined,
  JournalOutlined,
  // CalendarOutlined,
  RubricOutlined,
  ListDashedSlantedOutlined,
  BooksTwoOutlined,
  TeacherResourceOutlined,
  ScienceOutlined,
  CalendarScheduleOutlined,
  ReloadArrowOutlined,
  ClockArrowsOutlined,
  InternalAssessmentOutlined,
  ExternalAssessmentOutlined,
  AssessmentandEvaluationOutlined,
  QuickTaskOutlined,
} from "@toddle-edu/ds-icons";
import {
  getAcademicSetupType,
  getAvatarData,
  getIsBlueprintCourse,
} from "LearningCourses/modules/Utils";
import { Avatar, Badge } from "@toddle-edu/ds-web";

import {
  ASSIGNMENTS_ACCESS_PERMISSION,
  COURSE_GRADEBOOK_ACCESS_PERMISSION,
  ATTENDANCE_ACCESS_PERMISSION,
  CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
  // CAN_VIEW_CALENDAR_MODULE_SETTING,
  CAN_VIEW_COURSE_FLOW_PERMISSION,
  CAN_VIEW_COURSE_SETTINGS_PERMISSION,
  CAN_VIEW_COURSE_ASSESSMENT_TOOLS_PERMISSION,
  CLASS_SETTINGS_ACCESS_PERMISSION,
  // CAN_VIEW_COURSE_RECYCLE_BIN_PERMISSION,
  MANAGE_COURSE_ASSOCIATED_CLASSES_PERMISSION,
  MANAGE_COURSE_STAFF_MEMBERS_PERMISSION,
  CAN_MANAGE_COURSE_STANDARDS,
  USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
  IS_GRADEBOOK_TABS_NAVIGATION_ENABLED,
  GRADING_VISIBILITY_SETTINGS_PERM,
  CAN_VIEW_COURSE_HOME_PAGE,
  GRADING_VISIBILITY_SETTINGS_V2_PERM,
  CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
  //CLASS_PLANNER_PERMISSION,
  CLASS_PLANNER_PERMISSION,
  CAN_MANAGE_NAVIGATION_SETTINGS,
  CAN_VIEW_IA_EA_MODULE,
  PSOW_ROEP_ACCESS_PERMISSION,
  COURSE_AND_CLASS_NAVIGATION_SETTING,
  CAN_VIEW_CLASS_ANNOUNCEMENT_MODULE,
  CAN_VIEW_LTI_TOOLS,
} from "Constants/permissionConstants";
import {
  ltiToolImages,
  enhanceLTIName,
} from "SchoolSetup/routes/LTISettings/modules/LTISettingsUtils.js";
import {
  getCurrentCurriculumProgramType,
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import ACLStore from "lib/aclStore";
import { store } from "store/createStore";
import {
  COURSE_BASED_GRADING,
  CURRICULUM_TYPE_MYP,
  PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
  PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";
import {
  getIsConfigurationEnabledForCPAY,
  getSettingValue,
} from "modules/PermissionModule";

import {
  getSelectedLearningCourse,
  isClassModuleVisible,
  isLearningCourseModuleVisible,
  UNIT,
  CARD_VIEW,
  TIMELINE_VIEW,
  COURSE_OVERVIEW,
  SCHEDULE,
  isBluePrintTeacherCourseSyncEnabled,
  getIsBlueprintSyncRevampEnabled,
  COURSE_FLOW,
  COURSE_PLAN,
  getSelectedLearningCourseId,
  getLearningCourseVariables,
  getIsBlueprintSyncHistoryV2Enabled,
  getCurrentPlannerElementSetForStandardsFromState,
} from "./LearningCourseUtils";
import { getIsCoursePlanRouteEnabled } from "Utils/ACLStoreUtils";
import {
  getLearningCourseDetailsFromCache,
  getSubjectDetailFromCache,
} from "./LearningCourseGraphqlHelpers";
import ACLStorage from "lib/aclService";
import { getLTIServicesForCurriculumFromCache } from "LTIComponent/modules/LTIGraphqlHelpers";
import {
  LTI_SERVICE_DETAILS,
  getLTIName,
} from "AppComponents/LTIComponent/modules/Utils";

const styles = {
  ltiToolIcon: {
    width: "2.5rem",
    height: "2.5rem",
    objectFit: "contain",
  },
};

const SIDEBAR_KEYS_TO_NAVIGATION_CONFIG_MODULES_MAPPING = {
  staff: {
    courseLevel: {
      HOME: "home_page",
      COURSE_FLOW: "course_flow",
      STANDARDS: "standards",
      ASSESSMENT_TOOLS_SETUP: "assessment_tools",
      LTI_TOOLS: "lti_tools",
    },
    classLevel: {
      HOME: "home_page",
      CLASS_ROOM: "assignments",
      GRADEBOOK: "gradeBook",
      ATTENDANCE: "attendance",
      JOURNAL: "class_portfolio",
      UBD_ROUTINES: "routines",
      ANNOUNCEMENT: "announcements",
      CLASS_PLANNER: "weekly_planner",
      PRACTICAL_ACTIVITIES: "psow",
      RECORD_OF_EXPERIMENTAL_PROGRAMMES: "psow",
      PROJECT_GROUP: "project_group",
    },
  },
  student: {
    HOME: "home_page",
    COURSE_FLOW: "course_flow", // TODO: this will be removed once depreciated from 1B team
    COURSE_PLAN: "course_flow",
    CLASS_ROOM: "assignments",
    JOURNAL: "class_portfolio",
    ROUTINES: "routines",
    LTI_TOOLS: "lti_tools",
    ANNOUNCEMENT: "announcements",
    PROJECT_GROUP: "project_group",
    PRACTICAL_ACTIVITIES: "psow",
    RECORD_OF_EXPERIMENTAL_PROGRAMMES: "psow",
  },
  parent: {
    HOME: "home_page",
    CLASSPLANNERS: "weekly_planner",
    COURSE_FLOW: "course_flow", // TODO: this will be removed once depreciated from 1B team
    COURSE_PLAN: "course_flow",
    CLASS_ROOM: "assignments",
    JOURNAL: "class_portfolio",
    ROUTINES: "routines",
    ANNOUNCEMENT: "announcements",
    PROJECT_GROUP: "project_group",
  },
};

export const COURSE_AND_CLASS_NAVIGATION_CONFIG_KEY =
  "CourseAndClassNavigation";

export const getIsStandardsApplicable = () => {
  const state = store?.getState();
  const currentCurriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    null
  );

  const subjectIds = _.get(
    state,
    "learningCourse.selectedLearningCourse.subjects",
    []
  );
  const subjectId = _.first(subjectIds);
  const subject = getSubjectDetailFromCache({ subjectId });
  const subjectType = _.get(subject, "type", "GENERIC");
  const subjectTypesToExclude = ["CAS", "EE"];

  return !(
    currentCurriculumType === CURRICULUM_TYPE_DP &&
    _.includes(subjectTypesToExclude, subjectType)
  );
};

export const getIsGradeBookVisible = ({
  isV1,
  isFromNavigationSettings,
} = {}) => {
  const state = store?.getState();
  const subjectIds = _.get(
    state,
    "learningCourse.selectedLearningCourse.subjects",
    []
  );
  const currentCurriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    null
  );
  const subjectId = _.first(subjectIds);
  const subject = getSubjectDetailFromCache({ subjectId });
  const subjectType = _.get(subject, "type", "GENERIC");
  const subjectTypesToExclude = ["CAS", "EE"];
  const isTabNavigationEnabled = getIsConfigurationEnabledForCPAY({
    configuration: IS_GRADEBOOK_TABS_NAVIGATION_ENABLED,
  });
  const isDp = currentCurriculumType === CURRICULUM_TYPE_DP;
  const isCASorEE = _.includes(subjectTypesToExclude, subjectType);
  if (isFromNavigationSettings) {
    return !isDp || !isCASorEE;
  }
  return (
    (!isDp || !isCASorEE) &&
    (isV1 ? !isTabNavigationEnabled : isTabNavigationEnabled)
  );
};

export const getIsRoepApplicable = () => {
  const state = store?.getState();
  const curriculumType = getCurrentCurriculumProgramType(state);
  const isDPCurriculum = _.isEqual(curriculumType, CURRICULUM_TYPE_DP);
  if (!isDPCurriculum) {
    return false;
  }
  const academicYearId = getSelectedAcademicYearId(state);
  const learningCourseId = getSelectedLearningCourseId(state);
  const learningCourseVariables = getLearningCourseVariables({
    learningCourseId,
    academicYearId,
  });
  const learningCourseDetails = getLearningCourseDetailsFromCache(
    learningCourseVariables
  );
  const isRoep = _.get(
    learningCourseDetails,
    "subjects[0].metadata.isRoep",
    false
  );
  return isRoep;
};

export const getIsPracticalActivitiesApplicable = () => {
  const state = store?.getState();
  const curriculumType = getCurrentCurriculumProgramType(state);
  const isDPCurriculum = _.isEqual(curriculumType, CURRICULUM_TYPE_DP);
  if (!isDPCurriculum) {
    return false;
  }
  const academicYearId = getSelectedAcademicYearId(state);
  const learningCourseId = getSelectedLearningCourseId(state);
  const learningCourseVariables = getLearningCourseVariables({
    learningCourseId,
    academicYearId,
  });
  const learningCourseDetails = getLearningCourseDetailsFromCache(
    learningCourseVariables
  );
  const isPsow = _.get(
    learningCourseDetails,
    "subjects[0].metadata.isPsow",
    false
  );
  const isESAS = _.get(
    learningCourseDetails,
    "subjects[0].metadata.isESAS",
    false
  );
  return isPsow || isESAS;
};

const LEARNING_COURSE_MENU = [
  {
    id: "root",
    children: [
      "HOME",
      "COURSE_FLOW",
      "ASSESSMENT_TOOLS_SETUP",
      "STANDARDS",
      "SYNC_STATUS",
    ], // classes & divider will be dynamically added
  },
  {
    id: "HOME",
    parent: "root",
    label: "course:home",
    route: "home",
    icon: <HomeOutlined />,
    visibilityCheckFn: () => {
      /**
       * Checking RnP permission here instead of providing permission prop
       * Because `isLearningCourseModuleVisible` internally uses `getModuleSettingsValueByContext`
       * and for courseHomePage, that function will internally check addOn configuration value with learning course context
       * while the addOn configuration is on org context.
       **/
      return ACLStorage.getModuleSettingsValue(CAN_VIEW_COURSE_HOME_PAGE);
    },
  },
  {
    id: "COURSE_FLOW",
    parent: "root",
    label: "course:course_flow_lower",
    route: COURSE_FLOW,
    icon: <DashboardOutlined />,
    permission: CAN_VIEW_COURSE_FLOW_PERMISSION,
  },
  {
    id: "ASSESSMENT_TOOLS_SETUP",
    parent: "root",
    label: "common:le_assessmentTools_label",
    route: "assessment-tools-setup",
    icon: <RubricOutlined />,
    permission: CAN_VIEW_COURSE_ASSESSMENT_TOOLS_PERMISSION,
    visibilityCheckFn: () => {
      return ACLStore.can("FeatureFlag:EnableCourseAssessmentTools");
    },
  },
  {
    id: "STANDARDS",
    parent: "root",
    label: "common:standard_plural",
    route: "standards",
    isDynamicNode: true,
    icon: <ListDashedSlantedOutlined />,
    permission: CAN_MANAGE_COURSE_STANDARDS,
    visibilityCheckFn: () => {
      // First, check whether standards are relevant for the current learning course before any other permission checks
      const isStandardsApplicable = getIsStandardsApplicable();
      return isStandardsApplicable;
    },
  },
  {
    id: "SYNC_STATUS",
    parent: "root",
    label: "common:sync_status",
    route: "sync",
    showCustomIconWrapper: true,
    icon: <ReloadArrowOutlined />,
    visibilityCheckFn: () => {
      const state = store?.getState();
      const learningCourse = getSelectedLearningCourse(state);

      return (
        getIsBlueprintSyncHistoryV2Enabled() &&
        isBluePrintTeacherCourseSyncEnabled() &&
        getIsBlueprintSyncRevampEnabled() &&
        getIsBlueprintCourse(learningCourse)
      );
    },
  },
];

const CLASSES_MENU = [
  {
    id: "CLASS_ROOM",
    label: "common:assignments",
    icon: <AssessmentOutlined />,
    children: [],
    route: "classroom",
    permission: ASSIGNMENTS_ACCESS_PERMISSION,
  },
  {
    id: "PROJECT_GROUP",
    label: "{{projectGroupType}}",
    children: [],
    route: "projects/:projectGroupId",
    permission: CAN_VIEW_IA_EA_MODULE,
    isDynamicNode: true,
    dynamicNodeConfig: {
      id: "PROJECT_GROUP_{{projectGroupId}}",
      type: "PROJECT_GROUP",
      iconConfig: [
        {
          icon: <InternalAssessmentOutlined />,
          type: PROJECT_SUBTYPE_INTERNAL_ASSESSMENT,
        },
        {
          icon: <ExternalAssessmentOutlined />,
          type: PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT,
        },
      ],
    },
  },
  {
    id: "GRADEBOOK",
    label: "common:gradebook",
    icon: <TableOutlined />,
    children: ["ASSESSMENT_GRADEBOOK", "LEARNING_GOALS_GRADEBOOK"],
    permission: COURSE_GRADEBOOK_ACCESS_PERMISSION,
    visibilityCheckFn: () => {
      return getIsGradeBookVisible({ isV1: true });
    },
  },
  {
    id: "ASSESSMENT_GRADEBOOK",
    parent: "GRADEBOOK",
    label: "common:assessment_gradebook",
    route: "gradebook/assessments",
    isSubMenu: true,
    icon: <AssessmentApplicableOutlined />,
  },
  {
    id: "LEARNING_GOALS_GRADEBOOK",
    parent: "GRADEBOOK",
    label: "progressSummary:learning_goals_gradebook",
    route: "gradebook/learning-goals",
    isSubMenu: true,
    icon: <GoalsOutlined />,
    visibilityCheckFn: () => {
      const academicSetupType = getAcademicSetupType();
      return academicSetupType !== COURSE_BASED_GRADING;
    },
  },
  {
    id: "GRADEBOOK_V2",
    label: "common:gradebook",
    icon: <TableOutlined />,
    route: "gradebook",
    children: [],
    permission: COURSE_GRADEBOOK_ACCESS_PERMISSION,
    visibilityCheckFn: () => {
      return getIsGradeBookVisible();
    },
  },
  {
    id: "ATTENDANCE",
    label: "teacherHomePage:attendance",
    children: [],
    route: "attendance",
    icon: <AttendanceOutlined />,
    permission: ATTENDANCE_ACCESS_PERMISSION,
  },
  {
    id: "JOURNAL",
    label: "teacherHomePage:class_portfolio_new",
    children: [],
    route: "journal",
    icon: <JournalOutlined />,
    permission: CAN_VIEW_PORTFOLIO_POSTS_FOR_CLASSES,
    visibilityCheckFn: () => {
      const state = store?.getState();
      const curriculumType = getCurrentCurriculumProgramType(state);
      const isDPCurriculum = _.isEqual(curriculumType, CURRICULUM_TYPE_DP);
      if (!isDPCurriculum) {
        return true;
      }
      const allowedSubjectTypes = getSettingValue({
        name: "EnablePortfolioForDpCoreChild",
        currentCurriculumProgramId: getSelectedCurriculumId(state),
      });
      const academicYearId = getSelectedAcademicYearId(state);
      const learningCourseId = getSelectedLearningCourseId(state);
      const learningCourseVariables = getLearningCourseVariables({
        learningCourseId,
        academicYearId,
      });
      const learningCourseDetails = getLearningCourseDetailsFromCache(
        learningCourseVariables
      );
      const isDPcoreSubject =
        _.get(learningCourseDetails, "subjects[0].subjectGroup.type") ===
        "CORE";
      const subjectType = _.get(learningCourseDetails, "subjects[0].type", "");

      if (_.includes(allowedSubjectTypes, subjectType)) {
        return true;
      }
      return !isDPcoreSubject && isDPCurriculum;
    },
  },
  {
    id: "UBD_ROUTINES",
    label: "common:routines",
    children: [],
    route: "routines",
    icon: <ClockArrowsOutlined />,
    permission: CAN_VIEW_ROUTINE_POSTS_FOR_CLASSES,
    addOnContexts: [],
    visibilityCheckFn: () => {
      return ACLStore.can("EnableClassRoutines");
    },
  },
  {
    id: "ANNOUNCEMENT",
    label: "announcement:class_announcements",
    children: [],
    route: "circulars",
    levelId: "L1",
    icon: <QuickTaskOutlined />,
    permission: CAN_VIEW_CLASS_ANNOUNCEMENT_MODULE,
    visibilityCheckFn: () => ACLStore.can("FeatureFlag:ClassAnnouncement"),
    addOnContexts: [],
  },
  {
    id: "CLASS_PLANNER",
    label: "common:class_planner",
    children: [],
    route: "weekly-planners",
    icon: <CalendarScheduleOutlined />,
    permission: CLASS_PLANNER_PERMISSION,
    addOnContexts: [],
  },
  {
    id: "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
    label: "project:ROEP",
    icon: <AssessmentandEvaluationOutlined />,
    children: [],
    route: "recordofexperimentalprogrammes",
    permission: PSOW_ROEP_ACCESS_PERMISSION,
    visibilityCheckFn: () => {
      // First, check whether ROEP is relevant for the current learning course before any other permission checks
      const isRoepApplicable = getIsRoepApplicable();
      return isRoepApplicable;
    },
  },
  {
    id: "PRACTICAL_ACTIVITIES",
    label: "project:practical_PSOW",
    icon: <AssessmentandEvaluationOutlined />,
    children: [],
    route: "practicalactivities",
    permission: PSOW_ROEP_ACCESS_PERMISSION,
    visibilityCheckFn: () => {
      // First, check whether practical activities are relevant for the current learning course before any other permission checks
      const isPracticalActivitiesApplicable = getIsPracticalActivitiesApplicable();
      return isPracticalActivitiesApplicable;
    },
  },
];

const LEARNING_COURSE_FOOTER_MENU = [
  {
    id: "root",
    children: ["SYNCED_COURSES", "SYNCED_UPDATES", "SYNC_STATUS", "SETTINGS"],
  },
  {
    id: "SYNCED_COURSES",
    parent: "root",
    label: "common:synced_courses",
    route: "sync",
    showCustomIconWrapper: true,
    icon: <ReloadArrowOutlined />,
    visibilityCheckFn: () => {
      const state = store?.getState();
      const learningCourse = getSelectedLearningCourse(state);

      return (
        !getIsBlueprintSyncHistoryV2Enabled() &&
        isBluePrintTeacherCourseSyncEnabled() &&
        getIsBlueprintSyncRevampEnabled() &&
        getIsBlueprintCourse(learningCourse)
      );
    },
  },
  {
    id: "SYNCED_UPDATES",
    parent: "root",
    label: "common:synced_updates",
    route: "sync",
    showCustomIconWrapper: true,
    icon: <ReloadArrowOutlined />,
    visibilityCheckFn: () => {
      const state = store?.getState();
      const learningCourse = getSelectedLearningCourse(state);

      const isBlueprintAssociatedCourse = !!_.get(
        learningCourse,
        "bluePrintCourse.id"
      );

      return (
        !getIsBlueprintSyncHistoryV2Enabled() &&
        isBluePrintTeacherCourseSyncEnabled() &&
        getIsBlueprintSyncRevampEnabled() &&
        isBlueprintAssociatedCourse
      );
    },
  },
  {
    id: "SYNC_STATUS",
    parent: "root",
    label: "common:sync_status",
    route: "sync",
    showCustomIconWrapper: true,
    icon: <ReloadArrowOutlined />,
    visibilityCheckFn: () => {
      const state = store?.getState();
      const learningCourse = getSelectedLearningCourse(state);

      const isBlueprintAssociatedCourse = !!_.get(
        learningCourse,
        "bluePrintCourse.id"
      );

      return (
        getIsBlueprintSyncHistoryV2Enabled() &&
        isBluePrintTeacherCourseSyncEnabled() &&
        getIsBlueprintSyncRevampEnabled() &&
        isBlueprintAssociatedCourse
      );
    },
  },
  {
    id: "SETTINGS",
    parent: "root",
    label: "common:settings",
    icon: <SettingsOutlined />,
    showCustomIconWrapper: true,
    children: [
      "COURSE_SETTINGS",
      "SUBJECT_SETTINGS",
      "CLASS_SETTINGS:DIVIDER",
      "CLASS_SETTINGS",
    ],
    isCascadingMenu: true,
  },
  // TODO: Uncomment this and add "RECYCLE_BIN" in children array of root when recycle bin is available
  // {
  //   id: "RECYCLE_BIN",
  //   parent: "root",
  //   label: "common:recycle_bin",
  //   icon: <DeleteOutlined />,
  //   permission: CAN_VIEW_COURSE_RECYCLE_BIN_PERMISSION,
  //   children: [],
  // },
  {
    id: "COURSE_SETTINGS",
    parent: "SETTINGS",
    label: "course:course_settings",
    route: "course-settings",
    icon: <ManageMembersOutlined />,
    permission: CAN_VIEW_COURSE_SETTINGS_PERMISSION,
    children: [],
    visibilityCheckFn: ({ t, learningCourseId }) => {
      const tabOptions = getCourseSettingsTabOptions({ t, learningCourseId });
      return _.size(tabOptions) > 0;
    },
  },
  {
    id: "SUBJECT_SETTINGS",
    parent: "SETTINGS",
    label: "common:subject_settings",
    route: "subject-settings",
    icon: <BooksTwoOutlined />,
    children: [],
    visibilityCheckFn: ({ t, learningCourseId }) => {
      const tabOptions = getSubjectSettingsTabOptions({ t, learningCourseId });
      return _.size(tabOptions) > 0;
    },
  },
  {
    id: "CLASS_SETTINGS:DIVIDER",
    parent: "SETTINGS",
    isDivider: true,
  },
  {
    id: "CLASS_SETTINGS",
    parent: "SETTINGS",
    label: "common:class_settings",
    tier: 2,
    children: [],
  },
];

export const combinedMenu = _.concat(
  LEARNING_COURSE_MENU,
  CLASSES_MENU,
  LEARNING_COURSE_FOOTER_MENU
);

export const getSortedOptions = ({
  learningCourseId,
  classId,
  options,
  userType,
  nodeType,
  hasClassContext = false, // will be true when options key will have class id along with name eg. [classId]:CLASS_ROOM
}) => {
  if (!ACLStore.can(COURSE_AND_CLASS_NAVIGATION_SETTING)) return options;

  const courseAndClassNavigationConfig = getSettingValue({
    name: COURSE_AND_CLASS_NAVIGATION_CONFIG_KEY,
    ...(classId ? { courseId: classId } : { learningCourseId }),
  });

  if (!courseAndClassNavigationConfig) return options;

  let sidebarToConfigMappingObj;
  if (userType === "staff") {
    const nodeLevel = nodeType === "courseNodes" ? "courseLevel" : "classLevel";
    sidebarToConfigMappingObj =
      SIDEBAR_KEYS_TO_NAVIGATION_CONFIG_MODULES_MAPPING[userType][nodeLevel];
  } else {
    sidebarToConfigMappingObj =
      SIDEBAR_KEYS_TO_NAVIGATION_CONFIG_MODULES_MAPPING[userType];
  }

  const sortedOptions = _.sortBy(options, option => {
    let sidebarOptionKey = _.isObject(option)
      ? option?.id?.toLowerCase()
      : option?.toLowerCase();

    if (hasClassContext) {
      sidebarOptionKey = sidebarOptionKey?.split(":")?.[1];
      if (!sidebarOptionKey) return Infinity;
    }

    const mappedSidebarKey = _.findKey(sidebarToConfigMappingObj, (_, key) =>
      sidebarOptionKey?.includes(key?.toLowerCase())
    );

    if (!mappedSidebarKey) return Infinity;

    const configKey = sidebarToConfigMappingObj[mappedSidebarKey];

    return (
      courseAndClassNavigationConfig?.[nodeType]?.[userType]?.[configKey]
        ?.displaySequence ?? Infinity
    );
  });

  return sortedOptions;
};

const checkLearningCourseModuleVisibility = ({
  moduleId,
  learningCourseId,
}) => {
  if (!moduleId) return false;

  if (moduleId.startsWith("LTI_TOOLS:")) {
    const ltiToolDropdownOptions = getLTIToolOptionsForDefaultActiveTab();
    const toolExists = _.some(ltiToolDropdownOptions, { id: moduleId });
    return toolExists;
  }

  const { permission, visibilityCheckFn } =
    _.find(combinedMenu, { id: moduleId }) || {};

  let isModuleVisible = isLearningCourseModuleVisible({
    permission,
    learningCourseId,
  });

  if (_.isFunction(visibilityCheckFn)) {
    isModuleVisible =
      isModuleVisible && visibilityCheckFn({ t: _.noop, learningCourseId });
  }
  return isModuleVisible;
};

// This function will completely remove key from root level and its key from its parent children
export const removeOptionByKey = ({ options, keyToRemove }) => {
  const updatedOptions = _.filter(options, ({ key }) => {
    return key !== keyToRemove;
  });

  // Find the parent of the option to remove
  const parentKey = _.get(_.find(options, { key: keyToRemove }), "parent");

  // Update the parent's children if it exists
  if (parentKey) {
    const parentOption = _.find(updatedOptions, { key: parentKey });
    if (parentOption) {
      parentOption.children = _.without(parentOption.children, keyToRemove);
    }
  }

  return updatedOptions;
};

/**
 * Get LTI tool options from cache (without RnP permission check)
 * Used by Navigation Settings to show LTI tools in the table
 */
export const getLTIToolOptionsFromCache = () => {
  const state = store?.getState();
  const curriculumProgramId = getSelectedCurriculumId(state);

  const variables = {
    input: {
      entityId: [curriculumProgramId],
      entityType: ["CURRICULUM_PROGRAM"],
      credType: ["LTI_CONFIG"],
      context: "COURSE",
      isEnabledForUse: true,
    },
  };

  const ltiServicesFromCache = getLTIServicesForCurriculumFromCache(variables);
  const ltiServicesForCurriculum = _.get(
    ltiServicesFromCache,
    "getLTIIntegrationsCreds",
    []
  );

  const shouldEnableNewArchitecture = ACLStore.can(
    "FeatureFlag:EnableNewLTIArchitecture"
  );

  const filteredLTIServices = shouldEnableNewArchitecture
    ? ltiServicesForCurriculum
    : ltiServicesForCurriculum.filter(service => {
        const serviceDetails = LTI_SERVICE_DETAILS[service.serviceName];
        // Keep services that only:
        // - exist and have placement === "COURSE"
        return serviceDetails?.placement === "COURSE";
      });

  return filteredLTIServices;
};

/**
 * Get LTI tool dropdown options for sidebar (with RnP permission check)
 * Used by Sidebar to show/hide LTI tools based on RnP permission
 */
export const getLTIToolDropDownOptions = () => {
  // Check RnP permission for LTI Tools (Module:LTITools)
  const hasLTIToolsPermission = ACLStorage.getModuleSettingsValue(
    CAN_VIEW_LTI_TOOLS
  );

  if (!hasLTIToolsPermission) {
    return [];
  }

  return getLTIToolOptionsFromCache();
};

const getLTIToolOptionsForDefaultActiveTab = () => {
  const ltiServicesForCurriculum = getLTIToolDropDownOptions();

  const ltiToolOptions = ltiServicesForCurriculum.map(service => {
    const toolId = (service.name || service.serviceName).toUpperCase();
    return {
      id: `LTI_TOOLS:${toolId}`,
      label: service.name || service.serviceName,
    };
  });

  return ltiToolOptions;
};

export const getDefaultActiveTab = () => {
  const state = store?.getState();
  const learningCourseId = getSelectedLearningCourseId(state);

  const children = _.get(
    _.find(LEARNING_COURSE_MENU, { id: "root" }),
    "children",
    []
  );

  // Filter the combined menu to only include items that are in the root's children array
  let filteredMenu = _.filter(combinedMenu, ({ id }) => {
    return _.includes(children, id);
  });

  const ltiToolOptions = getLTIToolOptionsForDefaultActiveTab();

  filteredMenu = [...filteredMenu, ...ltiToolOptions];

  filteredMenu = getSortedOptions({
    options: filteredMenu,
    nodeType: "courseNodes",
    learningCourseId,
    userType: "staff",
  });

  // Find the first tab that has no permission or is visible based on its permission
  // This is the default tab that will be selected
  const defaultTab = _.find(
    filteredMenu,
    ({ permission = null, visibilityCheckFn }) => {
      let isModuleVisible = true;
      if (_.isFunction(visibilityCheckFn)) {
        isModuleVisible = visibilityCheckFn();
      }
      return isModuleVisible && isLearningCourseModuleVisible({ permission });
    }
  );

  // If a default tab is found, return its ID
  if (defaultTab) return defaultTab.id;

  return "";
};

export const getActiveTab = state =>
  _.get(state, "learningCourse.activeTab", getDefaultActiveTab());

export const checkClassModuleVisibility = ({
  moduleId,
  classId,
  learningCourseId,
}) => {
  if (!moduleId) return false;

  const classNode = _.find(CLASSES_MENU, { id: moduleId });

  if (!classNode) return false;

  const { permission, addOnContexts } = classNode;

  return isClassModuleVisible({
    permission,
    classId,
    learningCourseId,
    addOnContexts,
  });
};

export const getDefaultActiveClassTab = ({ classId, learningCourseId }) => {
  const sortedClassesMenu = getSortedOptions({
    options: CLASSES_MENU,
    nodeType: "classNodes",
    learningCourseId,
    userType: "staff",
  });

  // Find the first visible top-level module
  const defaultModule = _.find(
    sortedClassesMenu,
    ({ permission, visibilityCheckFn, addOnContexts, parent }) => {
      let isVisible =
        !parent &&
        isClassModuleVisible({
          permission,
          classId,
          learningCourseId,
          addOnContexts,
        });

      if (_.isFunction(visibilityCheckFn)) {
        isVisible = isVisible && visibilityCheckFn();
      }

      return isVisible;
    }
  );

  if (!defaultModule) return "";

  // If module has a route, return its ID
  if (defaultModule.route) {
    if (defaultModule.id === "PROJECT_GROUP") {
      const projectId = getIaEaProjectId({ learningCourseId, classId });
      return `PROJECT_GROUP_${projectId}`;
    }

    return defaultModule.id;
  }

  // If module doesn't have a route but has children, find first visible child
  if (defaultModule.children && defaultModule.children.length > 0) {
    for (const childId of defaultModule.children) {
      const childModule = _.find(sortedClassesMenu, { id: childId });
      if (!childModule) continue;

      let isChildVisible = isClassModuleVisible({
        permission: childModule.permission,
        classId,
        learningCourseId,
        addOnContexts: childModule?.addOnContexts,
      });

      if (_.isFunction(childModule.visibilityCheckFn)) {
        isChildVisible = isChildVisible && childModule.visibilityCheckFn();
      }

      if (isChildVisible) {
        return childId; // Return first visible child's ID
      }
    }
  }

  // Fallback to original module ID if no visible children found
  return defaultModule.id;
};

export const getRouteByKey = key => {
  const keys = key.split(":");

  let moduleId, classId;
  if (_.size(keys) > 1) {
    // Check if this is the new LTI_TOOLS:TOOLNAME format
    if (keys[0] === "LTI_TOOLS") {
      // New format: LTI_TOOLS:TOOLNAME
      const toolName = keys[1].toLowerCase();
      return `lti-tools/${encodeURIComponent(toolName)}`;
    } else {
      // Standard format: CLASSID:MODULEID
      [classId, moduleId] = keys;
    }
  } else {
    // Single part key
    [moduleId] = keys;
  }

  //handling project group dynamic routes
  if (moduleId && moduleId.startsWith("PROJECT_GROUP_")) {
    const parts = moduleId.split("_");
    const projectGroupId = parts[parts.length - 1];
    return `class/${classId}/projects/${projectGroupId}`;
  }

  if (moduleId == "COURSE_FLOW" && getIsCoursePlanRouteEnabled()) {
    return COURSE_PLAN;
  }

  let route = _.get(_.find(combinedMenu, { id: moduleId }), "route", "");

  if (classId) {
    if (moduleId === "CLASS_SETTINGS") {
      route = `class-settings/${classId}`;
    } else {
      route = `class/${classId}/${route}`;
    }
  }

  return route;
};

export const extractTabKeyFromRoutes = ({ routes, params, activeTab }) => {
  const classId = _.get(params, "course_id", null);
  const learningCourseId = _.get(params, "learningCourseId", null);
  const ltiToolName = _.get(params, "tool_id", null);
  const projectGroupId = _.get(params, "projectGroup", null);

  let tabKey;
  if (classId) {
    const activeTabData = activeTab?.split(":");
    const isClassIdFromStateSame = activeTabData?.[0] === classId;

    const classSettingsIndex = _.findIndex(routes, {
      path: "class-settings/:course_id",
    });

    const isClassSettingsRoute = classSettingsIndex > -1;

    if (isClassSettingsRoute) {
      return `${classId}:CLASS_SETTINGS`;
    }

    const classIdIndex = _.findIndex(routes, {
      path: "class/:course_id",
    });

    // Get the base route (level 1)
    const baseRoute = routes[classIdIndex + 1]?.path;
    // To preserve last selected tab in case of same class
    if (!baseRoute) {
      const moduleId = activeTabData?.[1];
      const isClassModuleVisible = checkClassModuleVisibility({
        moduleId,
        classId,
        learningCourseId,
      });

      if (isClassIdFromStateSame && isClassModuleVisible) {
        return activeTab;
      }

      const defaultActiveTab = getDefaultActiveClassTab({
        classId,
        learningCourseId,
      });

      return defaultActiveTab ? `${classId}:${defaultActiveTab}` : "";
    }

    //handling dynamic route
    if (baseRoute === "projects" && projectGroupId) {
      return `${classId}:PROJECT_GROUP_${projectGroupId}`;
    }

    // Check if base route matches any menu item
    const module = _.find(CLASSES_MENU, { route: baseRoute });
    let moduleKey = _.get(module, "id", null);

    if (moduleKey) {
      const { permission, visibilityCheckFn, addOnContexts } = module;
      let isVisible = isClassModuleVisible({
        classId,
        permission,
        learningCourseId,
        addOnContexts,
      });

      if (_.isFunction(visibilityCheckFn)) {
        isVisible = isVisible && visibilityCheckFn();
      }

      if (!isVisible) {
        moduleKey = "";
      }
    }

    // For nested routes, we need to check the next route
    if (!moduleKey && routes[classIdIndex + 2]) {
      const nextRoute = routes[classIdIndex + 2].path;

      // Create potential full path
      let fullPath = `${baseRoute}/${nextRoute.replace(/^\//, "")}`;

      // Handle route parameters if present
      const paramMatches = fullPath.match(/(?::)(\w+)/g);
      if (paramMatches) {
        paramMatches.forEach(match => {
          const paramName = match.substring(1);
          const paramValue = _.get(params, paramName, "");
          if (paramValue) {
            fullPath = fullPath.replace(match, paramValue);
          }
        });
      }

      // Check for a match with the full path
      moduleKey = _.get(_.find(CLASSES_MENU, { route: fullPath }), "id", "");
    }

    tabKey = `${classId}:${moduleKey}`;
  } else {
    const learningCourseIdIndex = _.findIndex(routes, {
      path: "learning-course/:learningCourseId",
    });

    const route = routes[learningCourseIdIndex + 1]?.path;

    const defaultTab = getDefaultActiveTab();
    tabKey =
      activeTab && activeTab.startsWith("LTI_TOOLS:") ? activeTab : defaultTab;

    // Check for LTI tool route
    if (route === "lti-tools/:tool_id") {
      // If we have a tool name, this is an LTI tool route
      if (ltiToolName) {
        // Format: LTI_TOOLS:TOOLNAME
        tabKey = `LTI_TOOLS:${ltiToolName.toUpperCase()}`;
        return tabKey;
      }
    }

    if (!route) {
      if (activeTab && !activeTab.includes(":")) {
        tabKey = activeTab;
      }
      const isModuleVisible = checkLearningCourseModuleVisibility({
        moduleId: tabKey,
        learningCourseId,
      });

      if (!isModuleVisible) {
        tabKey = defaultTab;
      }
    } else if (_.includes([UNIT, COURSE_FLOW, COURSE_PLAN, SCHEDULE], route)) {
      tabKey = "COURSE_FLOW";
    } else {
      const combinedMenu = _.concat(
        LEARNING_COURSE_MENU,
        LEARNING_COURSE_FOOTER_MENU
      );

      const matchingOptions = _.filter(combinedMenu, { route });

      if (_.size(matchingOptions) > 1) {
        // first visible option
        const visibleOption = _.find(matchingOptions, option => {
          const { visibilityCheckFn } = option;
          if (_.isFunction(visibilityCheckFn)) {
            return visibilityCheckFn({ learningCourseId });
          }
          return true;
        });
        tabKey = _.get(
          visibleOption,
          "id",
          _.get(_.first(matchingOptions), "id", "")
        );
      } else {
        tabKey = _.get(_.find(combinedMenu, { route }), "id", "");
      }
    }
  }

  return tabKey;
};

export const getRouteKey = ({ tabKey, currentCourseViewType }) => {
  const isCoursePlanRouteEnabled = getIsCoursePlanRouteEnabled();

  if (!isCoursePlanRouteEnabled && tabKey === "COURSE_FLOW") {
    if (
      _.includes(
        [CARD_VIEW, TIMELINE_VIEW, COURSE_OVERVIEW],
        currentCourseViewType
      )
    ) {
      return `${UNIT}/${currentCourseViewType}`;
    } else if (currentCourseViewType === SCHEDULE) {
      return SCHEDULE;
    }
  }
  return getRouteByKey(tabKey);
};

export const getLtiToolIcon = (serviceName, toolName) => {
  let iconKey;
  //using tool name as key for custom LTI tools
  if (serviceName.toUpperCase() === "CUSTOM") {
    iconKey = toolName.toLowerCase();
  } else {
    const enhancedName = enhanceLTIName[serviceName.toUpperCase()];
    iconKey = enhancedName
      ? enhancedName.toLowerCase()
      : serviceName.toLowerCase();
  }

  const iconUrl = ltiToolImages[iconKey];

  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt={toolName || serviceName}
        style={styles.ltiToolIcon}
      />
    );
  }

  // Fallback
  return <TeacherResourceOutlined />;
};

export const addLtiToolsToSidebar = ({
  options,
  rootOption,
  ltiDropDownOptions,
  activeTab,
  t,
}) => {
  if (_.isEmpty(ltiDropDownOptions)) return;

  // Check if active tab is an LTI tool
  const isLtiToolActive = activeTab && activeTab.startsWith("LTI_TOOLS:");
  const ltiToolsKey = "LTI_TOOLS";

  // If there's only one LTI tool, add it directly to the root
  if (ltiDropDownOptions.length === 1) {
    const ltiTool = ltiDropDownOptions[0];
    const toolId = (ltiTool.name || ltiTool.serviceName).toUpperCase();
    const toolKey = `LTI_TOOLS:${toolId}`;

    // Create the tool option directly under root
    const toolOption = {
      key: toolKey,
      parent: "root", // Add directly to root
      title: ltiTool.name || getLTIName(ltiTool.serviceName),
      prefix: getLtiToolIcon(ltiTool.serviceName, ltiTool.name),
      route: `lti-tools/${(ltiTool.name || ltiTool.serviceName).toLowerCase()}`,
      type: "LTI_TOOL",
      tier: 1,
      isActive: activeTab === toolKey,
    };

    // Add to options and root children
    options.push(toolOption);
    rootOption.children.push(toolKey);
  }
  // If there are multiple LTI tools, use an accordion
  else {
    const ltiToolsExists = _.some(options, { key: ltiToolsKey });

    if (!ltiToolsExists) {
      const ltiToolsOption = {
        key: ltiToolsKey,
        parent: "root",
        title: t("configuration:lti_tools"),
        prefix: <ScienceOutlined />,
        children: [],
        listType: "accordion",
        tier: 2,
        isExpanded: isLtiToolActive,
      };

      options.push(ltiToolsOption);
      rootOption.children.push(ltiToolsKey);
    } else if (isLtiToolActive) {
      // If LTI tools menu already exists, ensure it's expanded when an LTI tool is active
      const ltiToolsOption = _.find(options, { key: ltiToolsKey });
      ltiToolsOption.isExpanded = true;
    }

    // Get reference to the LTI_TOOLS option
    const ltiToolsOption = _.find(options, { key: ltiToolsKey });

    // Get current LTI tool IDs
    const currentLtiToolIds = _.map(ltiDropDownOptions, tool =>
      (tool.name || tool.serviceName).toUpperCase()
    );

    // Find existing LTI tool options
    const existingLtiTools = _.filter(
      options,
      option => option.parent === ltiToolsKey
    );

    // Remove tools that are no longer in the options
    _.forEach(existingLtiTools, tool => {
      if (!_.includes(currentLtiToolIds, tool.key.replace("LTI_TOOLS:", ""))) {
        // Remove from options array
        _.remove(options, { key: tool.key });

        // Remove from LTI_TOOLS children array
        _.remove(ltiToolsOption.children, key => key === tool.key);
      }
    });

    // Add or update tools from the options
    _.forEach(ltiDropDownOptions, ltiTool => {
      const toolId = (ltiTool.name || ltiTool.serviceName).toUpperCase();
      const toolKey = `LTI_TOOLS:${toolId}`;

      // Create the tool option
      const toolOption = {
        key: toolKey,
        parent: ltiToolsKey,
        title: ltiTool.name || getLTIName(ltiTool.serviceName),
        prefix: getLtiToolIcon(ltiTool.serviceName, ltiTool.name),
        route: `lti-tools/${(
          ltiTool.name || ltiTool.serviceName
        ).toLowerCase()}`,
        type: "LTI_TOOL",
        tier: 1,
        isActive: activeTab === toolKey,
      };

      // Check if this tool already exists
      const existingTool = _.find(options, { key: toolKey });

      if (existingTool) {
        // Update existing tool
        existingTool.title = toolOption.title;
        existingTool.route = toolOption.route;
        existingTool.isActive = toolOption.isActive;
        existingTool.prefix = toolOption.prefix;
      } else {
        // Add new tool
        options.push(toolOption);

        // Add to LTI_TOOLS children
        if (!_.includes(ltiToolsOption.children, toolKey)) {
          ltiToolsOption.children.push(toolKey);
        }
      }
    });
  }
};

const getSortedClassOption = ({ classOption, learningCourseId }) => {
  const childrenKeys = _.get(classOption, "children", []);
  const sortedChildrenKeys = getSortedOptions({
    options: childrenKeys,
    userType: "staff",
    nodeType: "classNodes",
    hasClassContext: true,
    learningCourseId,
  });
  return {
    ...classOption,
    children: sortedChildrenKeys,
  };
};

export const getSidebarOptions = ({
  t,
  activeTab = "",
  courseClasses,
  learningCourseId,
  ltiDropDownOptions = [],
  unreadCountByClasses = [],
}) => {
  /** Appending Default sidebar options */
  const options = _.reduce(
    LEARNING_COURSE_MENU,
    (acc, currOption) => {
      const {
        id,
        parent = null,
        children = [],
        icon = null,
        permission = null,
        visibilityCheckFn,
      } = currOption;

      const opt = {
        key: id,
        parent,
        title: getLabelForOption(currOption, t),
        children: _.cloneDeep(children),
        prefix: icon,
      };

      let isModuleVisible = isLearningCourseModuleVisible({
        permission,
        learningCourseId,
      });

      if (_.isFunction(visibilityCheckFn)) {
        isModuleVisible = isModuleVisible && visibilityCheckFn();
      }

      if (isModuleVisible) {
        acc.push(opt);
      }

      return acc;
    },
    []
  );

  const rootOption = _.find(options, { key: "root" });

  // Filter visible root children
  rootOption.children = _.map(_.filter(options, { parent: "root" }), "key");

  // Add LTI tools to the sidebar
  addLtiToolsToSidebar({
    options,
    rootOption,
    ltiDropDownOptions,
    activeTab,
    t,
  });

  const courseModulesList = _.cloneDeep(rootOption.children);

  const sortedCourseNodeKeys = getSortedOptions({
    options: courseModulesList,
    userType: "staff",
    nodeType: "courseNodes",
    learningCourseId,
  });

  rootOption.children = sortedCourseNodeKeys;

  if (!_.isEmpty(courseClasses)) {
    /** Appending classes */
    const topDividerKey = `TOP:DIVIDER`;

    _.forEach(
      courseClasses,
      ({
        id: classId,
        title,
        profileImageData,
        isArchived,
        projectGroups = [],
      }) => {
        const { color, name, AvatarIcon, iconType, url } = getAvatarData({
          id: classId,
          title,
          profileImageData,
        });

        const keys = activeTab.split(":");
        const [activeClassId] = keys;
        const isExpanded =
          activeClassId == classId || _.size(courseClasses) === 1;

        // dynamically adding classes to root
        const classOption = {
          key: classId,
          parent: "root",
          title: isArchived
            ? t("common:label_with_archived", { label: title })
            : title,
          prefix: (
            <Avatar
              icon={<AvatarIcon size="xx-small" />}
              color={color}
              name={name}
              iconType={iconType}
              shape="square"
              theme="light"
              src={url}
            />
          ),
          listType: "accordion",
          tier: 2,
          children: [],
          isExpanded,
          isClassRootNode: true,
        };

        const dividerKey = `${classId}:DIVIDER`;

        const classMenuOptions = [];
        _.forEach(
          CLASSES_MENU,
          ({
            id: moduleId,
            label,
            subtext,
            icon,
            route,
            permission,
            parent,
            children = [],
            isSubMenu = false,
            visibilityCheckFn,
            addOnContexts,
            isDynamicNode = false,
            dynamicNodeConfig = {},
          }) => {
            let isVisible = isClassModuleVisible({
              classId,
              permission,
              learningCourseId,
              addOnContexts,
            });

            if (_.isFunction(visibilityCheckFn)) {
              isVisible = isVisible && visibilityCheckFn();
            }

            const key = `${classId}:${moduleId}`;

            if (isVisible) {
              if (isDynamicNode) {
                switch (dynamicNodeConfig.type) {
                  case "PROJECT_GROUP":
                    _.forEach(projectGroups, projectGroup => {
                      const {
                        id: projectGroupId,
                        name,
                        subType,
                      } = projectGroup;

                      const dynamicId = `PROJECT_GROUP_${projectGroupId}`;
                      const key = `${classId}:${dynamicId}`;

                      const dynamicLabel = label.replace(
                        "{{projectGroupType}}",
                        name
                      );

                      const iconConfig = _.find(dynamicNodeConfig.iconConfig, {
                        type: subType,
                      });
                      const projectIcon = iconConfig ? iconConfig.icon : icon;

                      const dynamicRoute = `projects/${projectGroupId}`;

                      const projectGroupOption = {
                        key,
                        parent: classId,
                        children: [],
                        title: dynamicLabel,
                        prefix: projectIcon,
                        isArchived,
                        tier: 1,
                        route: dynamicRoute,
                        projectType: subType,
                        projectGroupId,
                      };

                      classOption.children.push(key);
                      classMenuOptions.push(projectGroupOption);
                    });

                    break;
                  default:
                    break;
                }
                return;
              }
              if (isSubMenu) {
                const parentKey = `${classId}:${parent}`;
                const parentOption = _.find(classMenuOptions, {
                  key: parentKey,
                });

                if (parentOption) {
                  if (parentOption.children) {
                    parentOption.children.push(key);
                  } else {
                    parentOption.children = [key];
                  }
                }
              } else {
                // adding modules to each class
                classOption.children.push(key);
              }

              const unreadAnnouncementsCount = _.get(
                _.find(unreadCountByClasses, {
                  id: classId,
                }),
                "circularFeedV3.unreadAnnouncementsCount",
                0
              );

              const showBadge = moduleId === "ANNOUNCEMENT";
              const prefixIcon = showBadge ? (
                <span>
                  <Badge
                    dsVersion="2.0"
                    containerStyle={{
                      display: "flex",
                    }}
                    offset={[4, 4]}
                    type="numeric"
                    size="xxx-small"
                    value={unreadAnnouncementsCount}
                  >
                    {icon}
                  </Badge>
                </span>
              ) : (
                icon
              );

              classMenuOptions.push({
                key,
                parent: isSubMenu ? `${classId}:${parent}` : classId,
                children: [],
                isCascadingMenu: !_.isEmpty(children),
                title: t(label),
                subtext: t(subtext),
                prefix: prefixIcon,
                isArchived, //TODO: will be removed later
                tier: 1,
                route,
                isSubMenu,
              });
            }
          }
        );

        // Replace options under class menu that have only one child with the child itself
        _.forEach(classMenuOptions, option => {
          const { children, key } = option;

          if (_.size(children) === 1) {
            const childKey = children[0];
            const childOption = _.find(classMenuOptions, { key: childKey });
            const parentIndex = _.indexOf(classOption?.children, key);

            if (parentIndex !== -1) {
              classOption.children[parentIndex] = childKey;
              childOption.parent = classId;
            }
          }
        });

        const filteredClassMenuRootNodes = _.filter(
          classMenuOptions,
          option => !_.get(option, "isSubMenu", false)
        );

        const isClassDropdownEmpty = _.isEmpty(filteredClassMenuRootNodes);

        if (isClassDropdownEmpty) return;

        // Add top divider only when there are both course & class modules visible
        const shouldAddTopDivider =
          !_.isEmpty(courseModulesList) &&
          !rootOption.children.includes(topDividerKey);

        if (shouldAddTopDivider) {
          options.push({
            key: topDividerKey,
            parent: "root",
            isDivider: true,
          });
          rootOption.children.push(topDividerKey);
        }

        rootOption.children.push(classId, dividerKey);

        const sortedClassOption = getSortedClassOption({
          classOption,
          learningCourseId,
        });

        options.push(
          {
            key: dividerKey,
            parent: "root",
            isDivider: true,
          },
          sortedClassOption,
          ...classMenuOptions
        );
      }
    );
  }

  return options;
};

export const getSidebarFooterOptions = ({
  t,
  learningCourseId,
  courseClasses,
  getCustomIconComponent,
}) => {
  let options = _.reduce(
    LEARNING_COURSE_FOOTER_MENU,
    (acc, currOption) => {
      const {
        id,
        parent = null,
        children = [],
        label,
        icon = null,
        showCustomIconWrapper,
        permission = null,
        visibilityCheckFn,
        ...rest
      } = currOption;

      if (_.isEqual(id, "root")) {
        return [
          {
            key: id,
            children,
          },
        ];
      }

      const visibleChildren = _.filter(children, childId => {
        const childOption = _.find(LEARNING_COURSE_FOOTER_MENU, {
          id: childId,
        });

        if (!childOption) return false;

        const { permission, visibilityCheckFn } = childOption;

        let isChildVisible = isLearningCourseModuleVisible({
          permission: permission,
          learningCourseId,
        });

        if (_.isFunction(visibilityCheckFn)) {
          isChildVisible =
            isChildVisible && visibilityCheckFn({ t, learningCourseId });
        }

        return isChildVisible;
      });

      const option = {
        key: id,
        parent,
        children: visibleChildren,
        title: label ? t(label) : null,
        prefix:
          showCustomIconWrapper && _.isFunction(getCustomIconComponent)
            ? getCustomIconComponent({ key: id, icon })
            : icon,
        ...rest,
      };

      let isModuleVisible = isLearningCourseModuleVisible({
        permission,
        learningCourseId,
      });

      if (_.isFunction(visibilityCheckFn)) {
        isModuleVisible =
          isModuleVisible && visibilityCheckFn({ t, learningCourseId });
      }

      if (isModuleVisible && (!children.length || visibleChildren.length)) {
        acc.push(option);
      } else {
        const parentOption = _.find(acc, { key: parent });
        if (parentOption) {
          parentOption.children = _.without(parentOption.children, id);
        }
      }

      return acc;
    },
    []
  );

  const classSettingsKey = "CLASS_SETTINGS";
  const courseSettingsKey = "COURSE_SETTINGS";
  const classSettingsOption = _.find(options, { key: classSettingsKey });
  const courseSettingsOption = _.find(options, { key: courseSettingsKey });

  const classSettingsOptions = [];

  _.forEach(courseClasses, ({ id: classId, title, profileImageData }) => {
    const { color, name, AvatarIcon, iconType, url } = getAvatarData({
      id: classId,
      title,
      profileImageData,
    });

    const key = `${classId}:CLASS_SETTINGS`;

    const classSettingOption = {
      key,
      parent: classSettingsKey,
      title,
      prefix: (
        <Avatar
          icon={<AvatarIcon size="xx-small" />}
          color={color}
          name={name}
          iconType={iconType}
          shape="square"
          theme="light"
          src={url}
        />
      ),
      children: [],
      permission: CLASS_SETTINGS_ACCESS_PERMISSION,
      route: `class-settings/${classId}`,
    };

    const isVisible = isClassModuleVisible({
      classId,
      permission: CLASS_SETTINGS_ACCESS_PERMISSION,
      learningCourseId,
    });

    if (isVisible) {
      classSettingsOption.children.push(key);
      classSettingsOptions.push(classSettingOption);
    }
  });

  options = _.concat(options, classSettingsOptions);

  if (_.isEmpty(classSettingsOptions) || !courseSettingsOption) {
    options = removeOptionByKey({
      options,
      keyToRemove: "CLASS_SETTINGS:DIVIDER",
    });

    // If no class settings options or course settings are available, remove appropriate items
    if (_.isEmpty(classSettingsOptions)) {
      options = removeOptionByKey({ options, keyToRemove: classSettingsKey });
    }

    if (_.isEmpty(classSettingsOptions) && !courseSettingsOption) {
      options = removeOptionByKey({ options, keyToRemove: "SETTINGS" });
    }
  }

  return options;
};

const SUBJECT_SETTINGS_TAB_OPTIONS = [
  {
    label: "course:grading_configurations",
    value: "grading-configurations",
    visibilityCheckFn: () => {
      const academicSetupType = getAcademicSetupType();
      const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;

      return (
        !isCourseBasedGrading &&
        getIsConfigurationEnabledForCPAY({
          configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
        })
      );
    },
  },
  {
    label: "common:grading_visibility",
    value: "grading-visibility",
    visibilityCheckFn: () => {
      const academicSetupType = getAcademicSetupType();
      const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;

      return (
        !isCourseBasedGrading &&
        ACLStore.can([
          GRADING_VISIBILITY_SETTINGS_PERM,
          GRADING_VISIBILITY_SETTINGS_V2_PERM,
        ])
      );
    },
  },
  {
    label: "common:myp_criteria_configuration",
    value: "myp-criteria-configuration",
    visibilityCheckFn: ({ curriculumType }) => {
      const academicSetupType = getAcademicSetupType();
      const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;

      return (
        !isCourseBasedGrading &&
        curriculumType === CURRICULUM_TYPE_MYP &&
        getIsConfigurationEnabledForCPAY({
          configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
        })
      );
    },
  },
];

const COURSE_SETTINGS_TAB_OPTIONS = [
  {
    label: "course:associated_classes_lowercase",
    value: "associated-classes",
    permission: MANAGE_COURSE_ASSOCIATED_CLASSES_PERMISSION,
    visibilityCheckFn: ({ isBlueprintCourse }) => {
      return !isBlueprintCourse;
    },
  },
  // {
  //   label: "common:module_settings",
  //   value: "module-settings",
  //   disabled: true,
  // },
  {
    label: "course:associated_courses",
    value: "associated-courses",
    //TODO - Uncomment this when associated courses are available
    // permission: MANAGE_COURSE_ASSOCIATED_CLASSES_PERMISSION,
    visibilityCheckFn: ({ isBlueprintCourse }) => {
      return (
        isBlueprintCourse &&
        isBluePrintTeacherCourseSyncEnabled() &&
        !getIsBlueprintSyncRevampEnabled()
      );
    },
  },
  {
    label: "common:staff_members_plural",
    value: "staff-members",
    permission: MANAGE_COURSE_STAFF_MEMBERS_PERMISSION,
  },
  {
    label: "course:grading_configurations",
    value: "grading-configurations",
    visibilityCheckFn: () => {
      const academicSetupType = getAcademicSetupType();
      const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;

      return (
        isCourseBasedGrading &&
        getIsConfigurationEnabledForCPAY({
          configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
        })
      );
    },
  },
  {
    label: "common:grading_visibility",
    value: "grading-visibility",
    visibilityCheckFn: () => {
      const academicSetupType = getAcademicSetupType();
      const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;

      return (
        isCourseBasedGrading &&
        ACLStore.can([
          GRADING_VISIBILITY_SETTINGS_PERM,
          GRADING_VISIBILITY_SETTINGS_V2_PERM,
        ])
      );
    },
  },
  {
    label: "common:sync_history",
    value: "sync-history",
    visibilityCheckFn: ({ isBlueprintAssociatedCourse, isBlueprintCourse }) => {
      return (
        (isBlueprintCourse || isBlueprintAssociatedCourse) &&
        isBluePrintTeacherCourseSyncEnabled() &&
        !getIsBlueprintSyncRevampEnabled()
      );
    },
  },
  {
    label: "common:navigation_settings",
    value: "navigation-settings",
    visibilityCheckFn: () => {
      const canManageNavigationSettings = ACLStorage.getModuleSettingsValue(
        CAN_MANAGE_NAVIGATION_SETTINGS
      );
      return canManageNavigationSettings;
    },
  },
];

export const getSubjectSettingsTabOptions = ({
  t,
  learningCourseId = null,
}) => {
  const state = store?.getState();
  const curriculumType = getCurrentCurriculumProgramType(state);

  const filteredTabOptions = _.filter(SUBJECT_SETTINGS_TAB_OPTIONS, option => {
    const { permission, visibilityCheckFn, isDisabled = false } = option || {};

    if (isDisabled) return false;
    let isVisible = isLearningCourseModuleVisible({
      permission,
      learningCourseId,
    });

    if (_.isFunction(visibilityCheckFn)) {
      isVisible = isVisible && visibilityCheckFn({ ...option, curriculumType });
    }

    return isVisible;
  });

  const tabOptions = _.map(filteredTabOptions, option => {
    return {
      ...option,
      label: t(option.label),
      route: option.value,
    };
  });

  return tabOptions;
};

export const getCourseSettingsTabOptions = ({ t, learningCourseId = null }) => {
  const state = store?.getState();
  const selectedLearningCourse = getSelectedLearningCourse(state);
  const isBlueprintCourse = getIsBlueprintCourse(selectedLearningCourse);
  const hasSingleSubject =
    _.size(_.get(selectedLearningCourse, "subjects")) === 1;

  const filteredTabOptions = _.filter(COURSE_SETTINGS_TAB_OPTIONS, option => {
    const { permission, visibilityCheckFn, isDisabled = false } = option || {};

    if (isDisabled) return false;
    let isVisible = isLearningCourseModuleVisible({
      permission,
      learningCourseId,
    });

    const isBlueprintAssociatedCourse = !!_.get(
      selectedLearningCourse,
      "bluePrintCourse.id"
    );

    if (_.isFunction(visibilityCheckFn)) {
      isVisible =
        isVisible &&
        visibilityCheckFn({
          ...option,
          isBlueprintCourse,
          isBlueprintAssociatedCourse,
          hasSingleSubject,
        });
    }

    return isVisible;
  });

  const tabOptions = _.map(filteredTabOptions, option => {
    return {
      ...option,
      label: t(option.label),
      route: option.value,
    };
  });

  return tabOptions;
};

export const getLearningCourseMenuOptions = options => {
  const rootNode = _.find(LEARNING_COURSE_MENU, { id: "root" });
  const learningCourseMenuChildren = _.get(rootNode, "children", []);

  return _.filter(options, option =>
    _.includes(learningCourseMenuChildren, option.key)
  );
};

export const getFirstValidNodeKey = (options, footerOptions) => {
  const allOptions = [...options, ...footerOptions];
  return _.find(allOptions, node => {
    const { key, children, parent } = node;
    const isValid =
      _.isEmpty(children) &&
      key !== "root" &&
      !_.includes(key, "DIVIDER") &&
      node.listType !== "accordion";
    if (!isValid) return false;
    if (parent && parent !== "root") {
      return _.some(allOptions, { key: parent });
    }
    return true;
  })?.key;
};

export const getClassSettingsKey = (footerOptions, classId) => {
  const key = `${classId}:CLASS_SETTINGS`;
  return _.some(footerOptions, { key }) ? key : undefined;
};

export const getCourseSettingsKey = footerOptions =>
  _.some(footerOptions, { key: "COURSE_SETTINGS" })
    ? "COURSE_SETTINGS"
    : undefined;

export const getRouteForNewClassWithSameModule = ({ classId }) => {
  const state = store?.getState();
  const activeTab = _.get(state, "learningCourse.activeTab");

  const tabParts = activeTab.split(":");
  const moduleKey = tabParts[1];

  const key = `${classId}:${moduleKey}`;
  return getRouteByKey(key);
};

export const getIaEaProjectId = ({
  learningCourseId = null,
  classId = null,
}) => {
  const state = store?.getState();
  const academicYearId = getSelectedAcademicYearId(state);
  const learningCourseVariables = getLearningCourseVariables({
    learningCourseId,
    academicYearId,
  });
  const learningCourseDetails = getLearningCourseDetailsFromCache(
    learningCourseVariables
  );
  const projectId = _.get(
    _.find(learningCourseDetails.classes, { id: classId }),
    "projectGroups[0].id"
  );
  return projectId;
};

export const getDynamicStandardsLabel = ({ t, label }) => {
  const state = store?.getState();
  const plannerElement = getCurrentPlannerElementSetForStandardsFromState(
    state
  );

  const { label: plannerElementLabel } = plannerElement;

  return plannerElementLabel ? plannerElementLabel : t(label);
};

export const getLabelForOption = (option = {}, t) => {
  const { id, isDynamicNode = false, label = "common:option" } = option;
  if (!id) return "";
  if (!isDynamicNode) return t(label);
  switch (id) {
    case "STANDARDS": {
      return getDynamicStandardsLabel({ t, label });
    }
    default:
      return t(label);
  }
};
